import React from "react";

import ImageSide from "../Login_page/components/ImageSide/ImageSide";
import LoginSide from "./components/LoginSide/LoginSide";

const LoginModule = () => {
    return(
        <>
            <LoginSide />
            <ImageSide />
        </>
    );
}

export default LoginModule;